import Image from './common/Image';
import DOMPurify from 'dompurify'
import PackageJson from "../../package.json";

function SliderItemCite(props) {
  const lang = props.lang;
  const newsColors = [
    {bg: 'tw-bg-teal-dark', fc: "tw-text-white", bc: "orange", img: 'zitat_light'}, 
    {bg:'tw-bg-teal-light', fc: "tw-text-white", bc: "white", img: 'zitat'}, 
    {bg:'tw-bg-yellow',  fc: "tw-text-teal", bc: "teal-ghost", img: 'zitat'}];

  let classNames =
    "slider-item-cite tw-w-72 tw-h-full ipad:tw-h-auto ipad:tw-w-full  ipad:tw-w-auto tw-absolute ipad:tw-relative tw-rounded-lg ipad:tw-rounded-2xl tw-bg-gray-medium tw-group flickity-cell tw-flex tw-flex-col tw-justify-between tw-py-8 tw-px-6 " +
    props.className;

  let subheadStyle = {wordBreak:'keep-all'};

  return (
    <span className={classNames+" "+newsColors[props.sliderBG%3].bg}>
        <img className="tw-absolute tw--top-3.5 tw-w-[40px] tw-h-[40px]" alt="Map" src={PackageJson.homepage+"images/"+newsColors[props.sliderBG%3].img+".svg"}/>  
        <div className={" tw-relative tw-inset-0 tw-items-center tw-justify-center tw-pt-0 tw-pb-5 "}>
          <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-flex-1 ">
            <p style={subheadStyle}
              className={"tw-font-semibold tw-max-w-full tw-text-base tw-leading-none md:tw-leading-6 tw-mt-1 "+newsColors[props.sliderBG%3].fc}
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.text[lang]) }}
            ></p>
          </div>
        </div>
        <div className="tw-flex">
          <Image
              className="tw-rounded-full tw-h-[65px] tw-w-[65px] tw-object-cover tw-block"
              src={props.image}
          />
          <p
              className={"tw-pl-4 tw-font-semibold tw-max-w-full tw-text-base tw-leading-none md:tw-leading-6 tw-mt-1 tw-text-white "+newsColors[props.sliderBG%3].fc}
            >
              {props.name}<br/>
              {props.club[lang]}
            </p>
        </div>
    </span>
  );
}

export default SliderItemCite;
